import { ref } from 'vue';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  type: ToastType;
  title: string;
  message?: string;
  duration?: number;
}

const toasts = ref<Toast[]>([]);

export function useToast() {
  const show = (options: Omit<Toast, 'id'>) => {
    const toast: Toast = {
      id: Date.now().toString(),
      duration: 5000,
      ...options
    };
    
    toasts.value.push(toast);
    
    if (toast.duration && toast.duration > 0) {
      setTimeout(() => {
        remove(toast.id);
      }, toast.duration);
    }
    
    return toast.id;
  };
  
  const remove = (id: string) => {
    const index = toasts.value.findIndex(t => t.id === id);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  };
  
  const success = (title: string, message?: string) => {
    return show({ type: 'success', title, message });
  };
  
  const error = (title: string, message?: string) => {
    return show({ type: 'error', title, message, duration: 0 }); // Errors don't auto-dismiss
  };
  
  const warning = (title: string, message?: string) => {
    return show({ type: 'warning', title, message });
  };
  
  const info = (title: string, message?: string) => {
    return show({ type: 'info', title, message });
  };
  
  const clear = () => {
    toasts.value = [];
  };
  
  return {
    toasts,
    show,
    remove,
    success,
    error,
    warning,
    info,
    clear
  };
}
